import Vue from 'vue'
import * as Vuex from 'vuex'

Vue.use(Vuex);

const LOGIN = 'LOGIN'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGOUT = 'LOGOUT'

export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem('loginData'),
    data: localStorage.getItem('loginData'),
    pending: false
  },
  mutations: {
    [LOGIN] (state, data) {
      state.pending = true
      state.data = data
    },
    [LOGIN_SUCCESS] (state) {
      state.isLoggedIn = true
      state.pending = false
    },
    [LOGOUT] (state) {
      state.isLoggedIn = false
    }
  },
  actions: {
    login ({commit}, data) {
      commit(LOGIN, data) // show spinner
      return new Promise(resolve => {
        localStorage.setItem('loginData', data)
        commit(LOGIN_SUCCESS)
        resolve()
      })
    },
    logout ({commit}) {
      localStorage.removeItem('loginData')
      commit(LOGOUT)
    }
  },
  getters: {
    isLoggedIn: state => {
      return state.isLoggedIn
    },
    token: () => {
      return localStorage.getItem('login')
    }
  }
})


// WEBPACK FOOTER //
// ./src/store/authentication.js